export default {
  search: require('./search/search.svg'),
  activeSearch: require('./search/searchActive.svg'),
  packageExists: require('./packageExists/avatar.svg'),
  activePackageExists: require('./packageExists/avatarActive.svg'),
  businessAccount: require('./business/business.svg'),
  activeBusinessAccount: require('./business/businessActive.svg'),
  fromPackage: require('./fromPackage/plane.svg'),
  calendar: require('./calendar-not-active/calendar.svg'),
  smallCalendar: require('./calendar/calendar.svg'),
  world: require('./world-not-active/world.svg'),
  smallWorld: require('./world/world.svg'),
  point: require('./search/searchActive.svg'),
  close: require('../../images/close/close.svg'),
};
